import React, { useState } from 'react';
import styles from './style.module.css';
import { clearTokenItem, TOKEN_KEY } from '../../utils/helpers';
import { useNavigate } from 'react-router';

const GearIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={styles.gearIcon}
  >
    <path d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"></path>
    <path d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32l1.41 1.41M2 12h2m16 0h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"></path>
  </svg>
);

const BuyerSettingsPage: React.FC = () => {
  const [is2faEnabled, setIs2faEnabled] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () =>
  {
      clearTokenItem(TOKEN_KEY.AUTH_TOKEN);
      navigate("/signIn");
  }

  return (
    <div className={styles.settingsContainer}>
      <header className={styles.header}>
        <h1>Settings</h1>
      </header>

      <div className={styles.content}>
        <section className={styles.settingsSection}>
          <div className={styles.sectionHeader}>
            <h2>Change Password</h2>
            <p>Keep your account safe with a new password</p>
          </div>
          <form>
            <div className={styles.formGroup}>
              <label htmlFor="current-password">Password</label>
              <input placeholder='********' id="current-password" type="password" className={styles.formInput} />
            </div>
            <div className={styles.formGroup}>
              <label htmlFor="new-password">New Password</label>
              <div className={styles.newPasswordWrapper}>
                <input id="new-password" type="password" className={styles.formInput} placeholder="********" />
                {/* <GearIcon /> */}
              </div>
            </div>
          </form>
        </section>

        <section className={`${styles.settingsSection} ${styles.twoFactorSection}`}>
          <div className={styles.sectionHeader}>
            <h2>Two-Factor Authentication (2FA)</h2>
            <p>Extra protection with SMS, email, or app codes</p>
          </div>
          <label className={styles.toggleSwitch}>
            <input type="checkbox" checked={is2faEnabled} onChange={() => setIs2faEnabled(!is2faEnabled)} className={styles.toggleInput} />
            <span className={styles.slider}></span>
          </label>
        </section>

        <section className={styles.settingsSection}>
          <a href="#" onClick={handleLogout} className={styles.logOutLink}>
            Log Out
          </a>
          <p className={styles.logOutDescription}>End active sessions instantly</p>
        </section>
      </div>
    </div>
  );
};

export default BuyerSettingsPage;
